import { Button } from "antd";
import Play from "icons/Play.svg";
import Pause from "icons/Pause.svg";
import FrameDown from "icons/minus.svg";
import FrameUp from "icons/FrameUp.svg";
import PlayDisabled from "icons/PlayDisabled.svg";
import PauseDisabled from "icons/PauseDisabled.svg";
import FrameDownDisabled from "icons/FrameDownDisabled.svg";
import FrameUpDisabled from "icons/FrameUpDisabled.svg";
import { ReactComponent as MinusIcon } from "icons/minusIcon.svg";

import styles from "./styles.module.scss";
import { useEffect } from "react";

export function SeekBarV1({
  isReadyToPlay,
  handlePlay,
  isPlaying,
  handlePreviousFrame,
  timestamps,
  currentFrame,
  handleSliderChange,
  handleNextFrame,
  isControlsDisabled,
  hideSeekbar,
  isLandscape,
  isDrawing,
  min,
  max,
  variant,
  setCurrentFrame,
  positions,
}: any) {
  const containerClassName = styles.seekbarColumn;
  const drawingLandscape = isLandscape && isDrawing ? true : false;

  function isMinusBtnDisabled() {
    if (variant === "onlyDisplayP7" && positions) {
      return currentFrame <= positions["P7"] - 6;
    }
    if (currentFrame <= 0) return true;
  }

  function isPlusBtnDisabled() {
    if (variant === "onlyDisplayP7" && positions) {
      return currentFrame >= positions["P7"] + 6;
    }
    return timestamps ? currentFrame >= timestamps.length - 1 : false;
  }

  return (
    <>
      <div
        className={
          isLandscape
            ? styles.landscapeCustomControlsRowContainer
            : styles.customControlsRowContainer
        }
        style={{
          visibility: `${hideSeekbar ? "hidden" : "visible"}`,
          justifyContent: `${drawingLandscape} ? "center" : ""}`,
          pointerEvents: isReadyToPlay ? "auto" : "none",
        }}
      >
        <div className={styles.customControlsRow}>
          <div className={containerClassName}>
            <div style={{ height: "30px", width: "30px", cursor: "pointer" }}>
              <MinusIcon height={30} width={30} onClick={handlePreviousFrame} />
            </div>
            {/* <Button
              onClick={handlePreviousFrame}
              disabled={isMinusBtnDisabled()}
              className={styles.frameButton}
            >
              <img
                src={isControlsDisabled ? FrameDownDisabled : FrameDown}
                alt=""
                style={{ height: "25px", width: "20px" }}
              />
            </Button> */}
            <Button
              className={styles.rangeBtn}
              onClick={handlePlay}
              disabled={isControlsDisabled}
              style={{ border: "none" }}
            >
              <img
                src={isPlaying ? Pause : Play}
                alt="play-pause-icon"
                style={{ height: "30px" }}
              />
            </Button>

            <input
              type="range"
              min={min || 0}
              max={max || (timestamps ? timestamps.length - 1 : 100)}
              value={currentFrame}
              onChange={handleSliderChange}
              disabled={isControlsDisabled}
            />
            <Button
              onClick={handleNextFrame}
              disabled={isPlusBtnDisabled()}
              className={styles.rangeBtn}
            >
              <img
                src={isControlsDisabled ? FrameUpDisabled : FrameUp}
                alt=""
                height={30}
              />
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}
